<div class="confirmation-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="confirm-body">
      <mat-icon class="confirm-icon {{ data.type || 'danger' }}">{{ iconName }}</mat-icon>
      <p class="confirm-message">{{ data.message }}</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="onCancel()">
      {{ data.cancelText || 'Cancel' }}
    </button>
    <button mat-flat-button [color]="confirmColor" type="button" (click)="onConfirm()">
      {{ data.confirmText || 'Confirm' }}
    </button>
  </mat-dialog-actions>
</div>
